import { render, staticRenderFns } from "./chiTietTraiCay.vue?vue&type=template&id=03b34939&scoped=true&"
import script from "./chiTietTraiCay.vue?vue&type=script&lang=js&"
export * from "./chiTietTraiCay.vue?vue&type=script&lang=js&"
import style0 from "./chiTietTraiCay.vue?vue&type=style&index=0&id=03b34939&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b34939",
  null
  
)

export default component.exports